<template>
	<div class="detail">
		<!-- 导航栏 -->
		<back-to :title="productList.title"></back-to>
		<!-- 轮播 -->
		<section class="detailSwiper">
			<van-swipe class="detailSwiper-swiper-bg" :loop="false" indicator-color="white">
				<van-swipe-item v-for="(item, index) in productList.pictureList" :key="index">
					<img v-lazy="item.url" v-if="!item.isMp4" />
					<video v-else ref="myVideo" :src="item.url" :controls="true" oncontextmenu="return false"
						muted="muted" autoplay="autoplay" loop="-1" controlslist="nodownload" class="video-box"></video>
				</van-swipe-item>
			</van-swipe>
		</section>
		<!-- 门票介绍 -->
		<section class="detailContent">
			<h2>{{productList.title}}</h2>
			<div class="detail-price-content">
				<!-- 价格 -->
				<span class="price-content-p" v-if="!productList.isFree && ticketsLength > 0">
					<p class='price-icon price-common'>¥</p>
					<p class='price-num price-common'>{{productList.price}}</p>
					<p class='price-font'>起</p>
					<p class='price-intro' @click="show = true">起价说明</p>
				</span>
				<span class="price-common" v-else-if="productList.isFree == false && ticketsLength==0">敬请期待</span>
				<span v-else>
					<img class="free-icon" src="../../assets/free_icon.png" alt="">
				</span>
				<!-- 周边门票 -->
				<span class="price-right">
					<p class='place-tag tag-common'>周边门票</p>
					<p class='type-tag tag-common'>{{productList.city}}</p>
				</span>
			</div>
			<div class='free-info-confirm' v-if="!productList.isFree">
				{{confirmTxt}}
			</div>
			<div class='free-recommend-content'>
				<div class='free-recommend'>
					<p class='free-recommend-common' v-for="(item, index) in recommed"> ● {{item}}</p>
				</div>
			</div>
			<div class="grid">
				<span class="grid-item">
					<p class="grid-item-text">编号:</p>
					<P class="grid-item-bottom">{{productList.productType}}{{productList.id}}</P>
				</span>
				<!-- <span class="grid-item" v-if="">
					<p class="grid-item-text">开放时间:</p>
					<P class="grid-item-bottom">{{productList.openTime}}</P>
				</span> -->
			</div>
		</section>
		<!-- 区票 -->
		<section class="detailTicket" v-if="ticketsLength > 0">
			<ul>
				<li v-for="(item,index) in productList.tickets" :key="index">
					<span class="detailTicket-t">
						<h2>{{item.skuName?item.skuName:item.name }}</h2>
						<p>￥{{item.price}}</p>
					</span>
					<span class="detailTicket-c">{{item.mpContent}}</span>
					<span class="detailTicket-b">
						<span>
							<p>购买说明</p>
							<p v-show="item.is_Electronic == true">电子票</p>
						</span>
						<span
							@click="$router.push({ path: '/choice',query:{id:$route.query.id,proTypeID:item.skuid,skuIndex:index,orderType:1}})">购买</span>
					</span>
				</li>
			</ul>
		</section>
		<!-- 详情 -->
		<section class="detailIntro">
			<van-tabs v-model="active" scrollspy sticky offset-top="46">
				<van-tab v-for="(item, index) in productList.msg" :key="index" :title="item.title">
					<div class="detailIntro-intro">
						<h2>{{item.title}}</h2>
						<div class="detailIntro-intro-spant" v-html="item.content"></div>
					</div>
				</van-tab>
				<van-tab v-for="(item, index) in productList.details" :key="index" :title="item.title">
					<div class="detailIntro-intro">
						<h2>{{item.title}}</h2>
						<div class="detailIntro-intro-span" v-html="item.content"></div>
					</div>
				</van-tab>
				<van-tab title="推荐商品" class="detailIntro-tab">
					<div class="detailIntro-intro detailIntro-intro-bot">
						<h2>推荐商品</h2>
						<ul class="detailIntro-intro-list">
							<li v-for="(item, index) in data_product_array" :key="index" @click="next(item.id)">
								<img v-lazy="item.imageUrl" />
								<span>{{item.title}}</span>
								<p>￥{{item.price}}</p>
							</li>
						</ul>
					</div>
				</van-tab>
			</van-tabs>
		</section>
		<!-- 购买按钮 -->
		<section class="detailBottom">
			<a href="tel:02425836666">咨询</a>
			<span class="" v-if="!productList.isFree && ticketsLength > 0"
				@click="$router.push({ path: '/choice',query:{id:$route.query.id,proTypeID:ticketsLength>0?productList.tickets[0].skuid:0,orderType:1}})">选择购买</span>
			<span v-else class="grays">选择购买</span>
		</section>
		<!-- 起价说明 -->
		<van-popup class="wrapper" v-model="show" position="bottom">
			<h2>- 起价说明 -</h2>
			<span>
				<label for="">起价说明</label>
				<p>1、本起价是在可售日期范围内的最低价。</p>
				<p>2、产品价格会根据您所选的出发日期、出行人数等而有所差别。</p>
				<p>3、此最低价格已是优惠促销后的价格。</p>
				<label for="">一次确认</label>
				<p>本产品展示价格即最终购买价格，您可直接下单购买，成功付款后我们将尽快与您联系，如有任何疑问可直接联系客服</p>
			</span>
		</van-popup>
	</div>
</template>
<script>
	import BackTo from "@/components/BackTo";
	export default {
		name: 'detail',
		components: {
			BackTo
		},
		data() {
			return {
				productList: [],
				ticketsLength: 0,
				confirmTxt: "",
				recommed: [],
				details: [],
				active: 0,
				data_product_array: [],
				organizationId: 1, //大客户判断
				title: '',
				show: false
			}
		},
		created() {
			this.organizationId = this.$route.query.organizationId ? this.$route.query.organizationId : 1
		},
		mounted() {
			this.getData()
		},
		methods: {
			next(id) {
				this.$router.push({
					path: '/detail',
					query: {
						id: id
					}
				})
				this.getData()
			},
			getGoodsList() {
				var data = {
					"merchantId": 0,
					"pageIndex": 1,
					"tagName": '周边游',
					"organizationId": this.$organizationId,
					"isZeroShow": true,
					"bigId": 0,
					"keyWord": "",
					"city": 0,
					"sort": 1,
					"tag": 0,
					"yh": 0,
					"startDate": "",
					"endDate": "",
					"startPrice": 0,
					"endPrice": 0,
					"webUserID": 0,
					"themeId": 0
				}

				this.$post(
					this.$apiList + '/NewNearTravel/GetNearTravel_List', data
				).then(res => {
					this.data_product_array = res.result.tag.tagProductList
				})
			},
			getData() {
				this.$post(
					this.$apiList + '/NewNearTravel/GetNearTravelProductByID?id=' + this.$route.query.id +
					'&MerchantId=0&OrganizationId=1&bigId=0', {}
				).then(res => {
					let ob = null
					let obindex
					res.result.productList[0].pictureList.forEach((e, index) => {
						if (e.url.indexOf('mp4') != -1) {
							e.isMp4 = true
							ob = JSON.stringify(e)
							obindex = index
						} else {
							e.isMp4 = false
						}
					});
					if (ob != null) {
						res.result.productList[0].pictureList.splice(obindex, 1)
						res.result.productList[0].pictureList.unshift(JSON.parse(ob))

					}

					var confirmFlag;
					var confirmTxt;
					if (res.result.productList[0].confirm == 1) {
						confirmFlag = true;
						confirmTxt = '本产品展示价格即最终购买价格，您可直接下单购买，成功付款后我们将尽快与您联系，如有任何疑问可直接联系客服。';
					} else {
						confirmFlag = false;
						confirmTxt = '此产品需要二次确认，您的甜程专属客服将在您下单后与您联系，请保持电话畅通。';
					}
					res.result.productList[0].msg = this.setImg(res.result.productList[0].msg)
					res.result.productList[0].city = res.result.productList[0].city.split(" ")[0]
					this.productList = res.result.productList[0]
					this.ticketsLength = res.result.productList[0].tickets.length
					this.confirmTxt = confirmTxt
					this.recommed = res.result.productList[0].highlights.split(";")
					this.getGoodsList()
				})
			},
			// 设置图片class
			setImg(data) {
				let img = data
				data.forEach((element, i) => {
					img[i].content = img[i].content.replace(/<p([\s\w"=\/\.:;]+)((?:(style="[^"]+")))/ig, '<p')
						.replace(/<p>/ig, '<p style="font-size: 15px; line-height: 25px;">')
						.replace(/<img([\s\w"-=\/\.:;]+)((?:(height="[^"]+")))/ig, '<img$1')
						.replace(/<img([\s\w"-=\/\.:;]+)((?:(width="[^"]+")))/ig, '<img$1')
						.replace(/<img([\s\w"-=\/\.:;]+)((?:(style="[^"]+")))/ig, '<img$1')
						.replace(/<img([\s\w"-=\/\.:;]+)((?:(alt="[^"]+")))/ig, '<img$1')
						.replace(/<img([\s\w"-=\/\.:;]+)/ig, '<img style="width: 100%;" $1');
				});
				return img
			}

		}
	}
</script>

<style>
	.detailSwiper,
	.detailSwiper-swiper-bg {
		width: 100%;
		height: 500px;
	}

	.detailSwiper-swiper-bg img,
	.detailSwiper-swiper-bg video {
		width: 100%;
		height: 100%;
		object-fit: fill;
	}

	.detailContent {
		width: 100%;
		padding: 26px;
		box-sizing: border-box;
	}

	.detailContent h2 {
		font-size: 32px;
		padding: 0 20px;
		box-sizing: border-box;
	}

	.detail-price-content {
		padding: 28px 20px 24px 20px;
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
	}

	.price-content-p {
		display: flex;
		align-items: flex-end;
		color: #345e6d;
		font-size: 24px;
	}

	.price-common {
		font-size: 42px;
		font-weight: 500;
		color: #ff6d00;
	}

	.price-font {
		color: #ff6d00;
		margin-bottom: 7px;
		padding-right: 32px;
	}

	.price-intro {
		margin-bottom: 7px;
	}

	.price-icon {
		padding-right: 10px;
	}

	.price-num {
		padding-right: 8px;
	}

	.price-right {
		display: flex;
		align-items: center;
	}

	.tag-common {
		width: 112px;
		height: 34px;
		padding: 0 3px;
		text-align: center;
		font-size: 22px;
		color: #fff;
	}

	.place-tag {
		background: rgba(254, 109, 2, 1);
		border-bottom-left-radius: 9px;
		border-top-left-radius: 9px;
	}

	.type-tag {
		background: rgba(102, 44, 144, 1);
		border-bottom-right-radius: 9px;
		border-top-right-radius: 9px;
	}

	.free-icon {
		width: 220px;
		height: 46px;
	}

	.free-info-confirm {
		border-radius: 8px;
		background: #fff6f0;
		color: #808080;
		font-size: 22px;
		width: 100%;
		padding: 15px 20px;
		box-sizing: border-box;
	}

	.free-recommend-content {
		width: 100%;
		padding: 24px 0;
		box-sizing: border-box;
	}

	.free-recommend {
		background: #fafafa;
		font-size: 22px;
		color: #333;
		padding: 24px 60px;
		border-radius: 8px;
		box-sizing: border-box;
		line-height: 30px;
	}

	.free-recommend-common {
		padding: 5px 0;
	}

	.grid {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 24px 20px;
		box-sizing: border-box;
		background-color: #fafafa;
		font-size: 24px;
	}

	.grid-item {
		flex: 1;
		display: flex;
		align-items: center;
		font-size: 28px;
	}

	.grid-item-text {
		color: #ff6c00;
		padding-right: 20px;
	}

	.detailTicket {
		width: 100%;
		padding: 30px 50px;
		box-sizing: border-box;
	}

	.detailTicket li {
		padding: 20px 0 40px 0;
		border-bottom: 1px solid #f6f6f6;
	}

	.detailTicket li:last-child {
		border: 0;
		margin-bottom: 20px;
	}

	.detailTicket-t,
	.detailTicket-c,
	.detailTicket-b {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.detailTicket-t h2 {
		font-weight: normal;
		font-size: 32px;
	}

	.detailTicket-t p {
		font-size: 30px;
		color: #ff8a00;
		font-weight: 600;
	}

	.detailTicket-c {
		font-size: 24px;
		color: #a6a6a6;
		padding: 7px 0;
	}

	.detailTicket-b span:first-child {
		display: flex;
		align-items: center;
		color: #345e6d;
		font-size: 22px;
	}

	.detailTicket-b span:first-child p:last-child {
		height: 28px;
		padding: 0 10px;
		line-height: 28px;
		text-align: center;
		font-size: 18px;
		background: #662d90;
		color: #fff;
		border-radius: 5px;
		margin-left: 17px;
	}

	.detailTicket-b span:last-child {
		width: 110px;
		height: 44px;
		font-size: 26px;
		text-align: center;
		border-radius: 8px;
		color: #fff;
		line-height: 44px;
		background: rgba(255, 109, 0, 1);
	}

	.detailIntro {
		width: 100%;
	}

	.detailIntro .van-tabs__nav {
		width: 100%;
		height: 88px;
		background-color: #d2d5dc;
		display: flex;
		align-items: center;
		padding: 0 30px;
		box-sizing: border-box;
	}

	.detailIntro .van-tab {
		width: 140px;
		height: 56px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 24px;
		color: #fff;
	}

	.detailIntro .van-tabs__wrap--scrollable .van-tab {
		padding: 0;
	}

	.detailIntro .van-tab--active {
		background-color: #ff8a00;
		width: 140px;
		line-height: 56px;
		height: 56px;
		text-align: center;
		border-radius: 16px;
	}

	.detailIntro .van-tabs__line {
		width: 0;
		height: 0;
	}

	.detailIntro-intro {
		width: 100%;
		padding: 0 48px;
		box-sizing: border-box;
		border-bottom: 30px solid #f6f6f6;
	}

	.detailIntro-intro-spant {
		font-size: 30px;
		padding: 48px 0;
		display: block;
		line-height: 48px;
	}


	.detailIntro-intro-span {
		padding: 48px 0;
		display: block;
		font-size: 22px;
		line-height: 38px;
		overflow: auto;
	}

	.detailIntro-intro h2 {
		font-size: 38px;
		vertical-align: middle;
		color: #333;
		font-weight: normal;
		margin-top: 64px;
	}

	.detailIntro-intro-bot {
		border: 0;
	}

	.detailIntro-intro-list {
		padding: 48px 0;
		display: block;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}

	.detailIntro-intro-list li {
		width: 310px;
		display: flex;
		flex-direction: column;
		margin-bottom: 20px;
	}

	.detailIntro-intro-list li img {
		width: 310px;
		height: 206px;
	}

	.detailIntro-intro-list li span {
		font-size: 26px;
		color: #333;
		margin-top: 8px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
		overflow: hidden;
	}

	.detailIntro-intro-list li p {
		font-size: 26px;
		color: #ff8a00;
		margin-top: 14px;
		margin-bottom: 5px;
		margin-left: auto;
		font-weight: bold;
	}
</style>